<template>
  <tour-control-map />
</template>

<script>
import TourControlMap from '@/components/TourControlMap'

export default {
  name: 'home',
  components: { TourControlMap }
}
</script>
